import { createAction, props } from '@ngrx/store';

export const loadShipment= createAction(
    '[Portals/Shipments] Load Shipment',
    props<{ shipmentId: string }>()
);
